import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Icon,
  Image,
} from 'semantic-ui-react'
import _ from 'lodash'

import { onOpen } from '_actions/createStoryModal'
import { changeDataNav } from '_actions/nav'
import _t from 'utils/i18n_helper'


const MydUserMenu = (props) => {
  const { location, auth } = props

  let menu = _.map(props.menu, m => {
    return (
      <div key={`menu_${m.labelKey}`} className='column'>
        <h3 className='ui center aligned icon header myd-user-menu-header-img'>
          <img alt='user menu' className='ui icon image' src={ m.image } />
          { _t(m.labelKey) }
        </h3>
        <div className='ui link big list'>
          {
            _.map(m.childs, child => {
              if(child.url === '0'){
                return (
                  <Link className='item' key={ child.id } to={{}} onClick={
                    e => {
                      e.preventDefault()
                      props.onOpenCreateStoryModal()

                    }
                  }>
                    <div className='ui grid'>
                      <div className='six wide column middle aligned'>
                        <img alt='user menu' className='ui image' src={ child.image } />
                      </div>
                      <div className='ten wide column middle aligned'>
                        <div className='content'>
                          <div className='header'>{ _t(child.labelKey) }</div>
                        </div>
                      </div>
                    </div>
                  </Link>
                )
              }

              let activeClass = location.pathname === child.url ? 'active' : ''

              if (child.url === '/eportfolio/mine' && _.includes(props.location.pathname, 'eportfolio')) {
                activeClass = 'active'
              }

              if (child.url === '/planning/setup' && _.includes(props.location.pathname, 'planning')) {
                activeClass = 'active'
              }

              let target = child.url.search('http') !== -1 ? '_blank' : null,
                link = target === '_blank' ? (
                  <a
                    key={`menu_${child.url}`}
                    className={ `item ${activeClass}` }
                    href={ child.url }
                    target={ target }
                    onClick={
                      () => props.toggleMainMenu({open: false})
                    }
                  >
                    <div className='ui two column grid'>
                      <div className='six wide column middle aligned'>
                        {
                          child.image === null ?
                          <Icon color='blue' name={child.icon} /> :
                          <Image src={ child.image } />
                        }
                      </div>
                      <div className='ten wide column middle aligned'>
                        <div className='content'>
                          <div className='header'>{ _t(child.labelKey) }</div>
                        </div>
                      </div>
                    </div>
                  </a>
                ) : (
                  <Link
                    key={`menu_${child.url}`}
                    className={ `item ${activeClass}` }
                    target={ target }
                    to={ child.url }
                    onClick={
                      () => {
                        props.toggleMainMenu({open: false})
                      }
                    }
                  >
                    <div className='ui two column grid'>
                      <div className='six wide column middle aligned'>
                        {
                          child.image === null ?
                          <Icon color='blue' name={child.icon} /> :
                          <Image src={ child.image } />
                        }
                      </div>
                      <div className='ten wide column middle aligned'>
                        <div className='content'>
                          <div className='header'>{ _t(child.labelKey) }</div>
                        </div>
                      </div>
                    </div>
                  </Link>
                )

              return link
            })
          }
        </div>
      </div>
    )
  })

  return (
    <div className='ui menu myd-main-menu top left'>
      <div className='ui container fluid'>
        <div className='ui equal width five column equal height basic segment grid'>
          {
            auth.user.isAdmin && !auth.user.isIndividual ?
            _t('MAIN-MENU-ADMIN-MESSAGE') :
            menu
          }
        </div>
      </div>
    </div>
  )
}

export default connect(
  (store) => ({
  }),
  (dispatch) => ({
    onOpenCreateStoryModal: bindActionCreators(onOpen, dispatch),
    toggleMainMenu: (v) => dispatch(changeDataNav(v)),
  })
)(MydUserMenu)
